import { PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export const NoDataComponent = (props: Props) => {
  const { children } = props;
  return <div className="rt-noData">{children}</div>;
};
